export class UStyles {
  public static classNames(...classes: (string | false | null | undefined)[]): string {
    return classes.filter(Boolean).join(" ");
  }
}
